import { render, staticRenderFns } from "./AppLayout.vue?vue&type=template&id=1f0bb26c&scoped=true&"
import script from "./AppLayout.vue?vue&type=script&lang=ts&"
export * from "./AppLayout.vue?vue&type=script&lang=ts&"
import style0 from "./AppLayout.vue?vue&type=style&index=0&id=1f0bb26c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0bb26c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CoreNavigationDrawer: require('/app/components/core/NavigationDrawer.vue').default,CoreRightNavigationDrawer: require('/app/components/core/RightNavigationDrawer.vue').default,CoreNavigationHeader: require('/app/components/core/NavigationHeader.vue').default})
